import { Text } from '../../../tokens';
import { ReactComponent as ErrorIcon } from '../../../../assets/shared/ic-shared-error.svg';

interface ErrorMessageProps {
  errorMessage: string;
}

export const ErrorMessage = ({ errorMessage }: ErrorMessageProps) => {
  return (
    <div className='flex h-[26px] items-center gap-[4px]'>
      <ErrorIcon />
      <Text.H10 className='text-text-negative-red'>{errorMessage}</Text.H10>
    </div>
  );
};
